import { Injectable } from "@angular/core";
import { DashboardMenuItem } from "../models/dashboard-menu-item";
import { DashboardItemType } from "../models/dashboard-item-type.enum";
import { BehaviorSubject } from "rxjs";
import { GoldenLayoutAdditionMode } from "../../golden-layout/golden-layout-addition-mode";
import {
  GoldenLayoutService,
  GLPopoutConfiguration,
} from "../../golden-layout/golden-layout-service";

export class BfxBaseMenuService {
  protected baseGoldenLayout: GoldenLayoutService;
  toggleMenu: BehaviorSubject<any>;

  constructor() {
    this.toggleMenu = new BehaviorSubject(null);
  }

  showHideMenu() {
    this.toggleMenu.next(null);
  }

  getMenuProvider(): Promise<DashboardMenuItem[]> {
    //must be overridden

    return null;
  }

  protected createMenuItem(
    label: string,
    dashboardItemType: DashboardItemType,
    additionMode: GoldenLayoutAdditionMode,
    allowMultiples: boolean = true,
    glPopoutConfig?: GLPopoutConfiguration,
  ): DashboardMenuItem {
    return this.createMenuItemWithId(
      label,
      label,
      dashboardItemType,
      additionMode,
      allowMultiples,
      glPopoutConfig,
    );
  }

  protected createMenuItemWithId(
    id: string,
    label: string,
    dashboardItemType: DashboardItemType,
    additionMode: GoldenLayoutAdditionMode,
    allowMultiples: boolean = true,
    glPopoutConfig?: GLPopoutConfiguration,
  ): DashboardMenuItem {
    let menuItem: DashboardMenuItem = new DashboardMenuItem();
    menuItem.id = id;
    menuItem.label = label;
    menuItem.command = (event) => this.launch(event.item, event.originalEvent);
    menuItem.dashboardItemType = dashboardItemType;
    menuItem.allowMultiples = allowMultiples;
    menuItem.additionMode = additionMode;
    glPopoutConfig != null
      ? (menuItem.glPopoutConfiguration = glPopoutConfig)
      : (menuItem.glPopoutConfiguration = null);
    if (dashboardItemType === DashboardItemType.Divider) {
      menuItem.separator = true;
    }
    return menuItem;
  }

  protected launch(menuItem: DashboardMenuItem, actionEvent: any): void {
    if (menuItem.glPopoutConfiguration != null) {
      menuItem.glPopoutConfiguration.sourceEvent = actionEvent;
      this.baseGoldenLayout.launchFromDashboard(
        menuItem.label,
        menuItem.dashboardItemType,
        menuItem.allowMultiples,
        menuItem.additionMode,
        menuItem.glPopoutConfiguration,
      );
    } else {
      this.baseGoldenLayout.launchFromDashboard(
        menuItem.label,
        menuItem.dashboardItemType,
        menuItem.allowMultiples,
        menuItem.additionMode,
      );
    }
  }
}
